<template lang="pug">
  div.map-popup.map-popup-city
    div
      div.tooltip__head
        p(v-html="fields.name").title Город
        span(@click="close($event)").close.close--small.close--tooltip
      div.tooltip__body
        div.tooltip__body-item
          span.info.info--grey Имя:
          span(v-html="fields.name").info
        div.tooltip__body-item
          span.info.info--grey Местоположение:
          span.info {{fields.lat}},{{fields.lng}}
      div.tooltip__foot
</template>

<script>
  import baseMapPopupMixin from './base-map-popup-mixin.js'

  export default {
    mixins: [baseMapPopupMixin],
    name: 'map-popup-city',
    data () {
      this.closeCallback = null
      return {
        fields: {}
      }
    },
    methods: {
      injectConf (options) {
        let {model, closeCallback} = options
        this.closeCallback = closeCallback
        this.fields = Object.assign({}, model || {})
        this.registerVueInMap()
      },
      close ($event) {
        this.closeCallback($event)
      }
    }
  }
</script>
